import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  user: {
    id: string;
    email: string;
    name: string;
    role: string;
    dealership_id?: string;
  };
}

class AuthService {
  async login(email: string, password: string): Promise<LoginResponse> {
    const response = await axios.post(`${API_URL}/v1/auth/login`, {
      email,
      password,
    });
    return response.data;
  }

  async logout(): Promise<void> {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
      await axios.post(
        `${API_URL}/v1/auth/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    }
  }

  async refreshToken(token: string): Promise<LoginResponse> {
    const response = await axios.post(
      `${API_URL}/v1/auth/refresh`,
      {
        refresh_token: token,
      }
    );
    return response.data;
  }
}

export const authService = new AuthService();